import {
  ACCESS_EXPIRES_AT_KEY,
  ACCESS_TOKEN_KEY,
  LEGACY_AUTH_TOKEN_KEY,
  REFRESH_EXPIRES_AT_KEY,
  REFRESH_TOKEN_KEY,
} from "./constants";

export type Tokens = {
  accessToken: string;
  accessTokenExpiresAt: number;
  refreshToken: string;
  refreshTokenExpiresAt: number;
};

const readString = (key: string): string | null => {
  const raw = localStorage.getItem(key);
  if (raw === null) return null;
  const trimmed = raw.trim();
  return trimmed === "" ? null : trimmed;
};

const readEpoch = (key: string): number | null => {
  const raw = readString(key);
  if (raw === null) return null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
};

export const tokenStorage = {
  getAccessToken: (): string | null => readString(ACCESS_TOKEN_KEY),
  getRefreshToken: (): string | null => readString(REFRESH_TOKEN_KEY),
  getAccessExpiresAt: (): number | null => readEpoch(ACCESS_EXPIRES_AT_KEY),
  getRefreshExpiresAt: (): number | null => readEpoch(REFRESH_EXPIRES_AT_KEY),

  setTokens: (tokens: Tokens): void => {
    localStorage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
    localStorage.setItem(
      ACCESS_EXPIRES_AT_KEY,
      String(tokens.accessTokenExpiresAt)
    );
    localStorage.setItem(
      REFRESH_EXPIRES_AT_KEY,
      String(tokens.refreshTokenExpiresAt)
    );
  },

  clearTokens: (): void => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(ACCESS_EXPIRES_AT_KEY);
    localStorage.removeItem(REFRESH_EXPIRES_AT_KEY);
    localStorage.removeItem(LEGACY_AUTH_TOKEN_KEY);
  },
};
